module.exports = __webpack_public_path__ + "img/alte_altaere.e3c6ed8f.jpg";